import { createSlice } from "@reduxjs/toolkit";
import {  re_kyc_nomineeNotOptedThunk } from "./thunk";

export const initialState = {
  re_kyc_nomineeNotOptedData: [],
  re_kyc_nomineeNotOptedError: {
    code: null,
    message: "",
    data: null,
  },
  re_kyc_nomineeNotOptedLoading: false,
};

const Re_kyc_nomineeNotOpted = createSlice({
  name: "Re_kyc_nomineeNotOpted",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(re_kyc_nomineeNotOptedThunk.pending, (state) => {
      state.re_kyc_nomineeNotOptedLoading = true;
      state.re_kyc_nomineeNotOptedError = initialState.re_kyc_nomineeNotOptedError;
    });
    builder.addCase(re_kyc_nomineeNotOptedThunk.fulfilled, (state, action) => {
      state.re_kyc_nomineeNotOptedData = action.payload.data;
      state.re_kyc_nomineeNotOptedLoading = false;
    });
    builder.addCase(re_kyc_nomineeNotOptedThunk.rejected, (state, action) => {
      state.re_kyc_nomineeNotOptedError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null,
      };
      state.re_kyc_nomineeNotOptedLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Re_kyc_nomineeNotOpted.actions;

export default Re_kyc_nomineeNotOpted.reducer;
